<template>
    <section
        class="border-y border-slate-700 bg-slate-800"
        aria-labelledby="final-cta-heading"
    >
        <div class="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
            <div
                class="flex flex-col items-center gap-6 text-center sm:flex-row sm:items-center sm:justify-between sm:text-left"
            >
                <div class="max-w-2xl">
                    <h2
                        id="final-cta-heading"
                        class="text-3xl font-semibold tracking-tight text-white"
                    >
                        {{ title }}
                    </h2>
                    <p class="mt-3 text-lg text-slate-200">
                        {{ subtitle }}
                    </p>
                </div>

                <a
                    :href="primaryButtonUrl"
                    class="inline-flex self-center items-center justify-center rounded-xl bg-white px-8 py-4 text-lg font-semibold text-slate-900 shadow-xs shadow-slate-950/40 transition-colors hover:bg-slate-100 sm:self-auto"
                >
                    {{ primaryButtonLabel }}
                </a>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    interface LandingPageFinalCallToActionProps {
        title: string
        subtitle: string
        primaryButtonLabel: string
        primaryButtonUrl: string
    }

    const props = defineProps<LandingPageFinalCallToActionProps>()
</script>
